export enum UserCampaignPhasedAccessType {
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  RELEASED = 'RELEASED',
}
